module.exports = __webpack_public_path__ + "img/Pic1@2x.e36e81c9.png";